import { render, staticRenderFns } from "./CommunicationFormModal.vue?vue&type=template&id=0adb770b&scoped=true&"
import script from "./CommunicationFormModal.vue?vue&type=script&lang=js&"
export * from "./CommunicationFormModal.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationFormModal.vue?vue&type=style&index=0&id=0adb770b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adb770b",
  null
  
)

export default component.exports